import { render, staticRenderFns } from "./sf-export.vue?vue&type=template&id=22a48ed4&scoped=true"
import script from "./sf-export.vue?vue&type=script&lang=ts"
export * from "./sf-export.vue?vue&type=script&lang=ts"
import style0 from "./sf-export.vue?vue&type=style&index=0&id=22a48ed4&prod&lang=scss&scoped=true"
import style1 from "./sf-export.vue?vue&type=style&index=1&id=22a48ed4&prod&lang=scss&scoped=true"
import style2 from "./sf-export.vue?vue&type=style&index=2&id=22a48ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a48ed4",
  null
  
)

export default component.exports